import 'core-js/es6/map';
import 'core-js/es6/set';
import 'raf/polyfill';
import './helpers/formDataPolyfill';
import thunkMiddleware from 'redux-thunk'
import { Route, Switch, HashRouter} from "react-router-dom";
import { applyMiddleware, createStore } from 'redux'
import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import  rootReducer from './reducers/reducers'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import LandingPage from './LandingPage'
import AdminPage from './components/pages/AdminPage'
import AdminObjects from  './components/pages/AdminObjects'
import LoginPage from './components/pages/LoginPage'
import InspectionPage from './components/pages/InspectionPage'
import Conclusions from './components/pages/Conclusions'
import ChangePswPage from './components/pages/ChangePswPage'
import ManageUser from './components/pages/ManageUser'
import CreateUser from './components/pages/CreateUser'
import ManageObject from './components/pages/ManageObject'
import OrgCabinet from './components/pages/OrgCabinet'
import OrgProfile from './components/pages/OrgProfile'
import OrgUsers from './components/pages/OrgUsers'
import Appeals from './components/pages/Appeals'
import Objects from './components/pages/Objects'
import ObjectsSearch from './components/pages/ObjectsSearch'
import Notification from './components/pages/Notification'
import NotificationsPage from './components/pages/NotificationsPage'
import NotificationCard from './components/pages/NotificationCard'
import ObjectsPage from './components/pages/ObjectsPage'
import ObjectsInspector from  './components/pages/ObjectsInspector'
import InspectionAppeals from  './components/pages/InspectionAppeals'
import theme from './components/themes/base'
import { createLogger } from 'redux-logger'
import SupervisionPage from './components/pages/SupervisionPage'
import { MuiPickersUtilsProvider } from 'material-ui-pickers';
// pick utils
import MomentUtils from '@date-io/moment';

global.requestAnimationFrame = cb => {
  setTimeout(cb, 0);
};

const logger = createLogger({})
const store = createStore(
    rootReducer,
    applyMiddleware(
        thunkMiddleware, // lets us dispatch() functions
        logger // neat middleware that logs actions
    )
)

const dzbnContext = React.createContext();

// store
//     .dispatch(init())
//     .then(() => console.log(store.getState()));

const App = () => (
<MuiPickersUtilsProvider utils={MomentUtils}>
<MuiThemeProvider theme={theme}>
    <Provider store={store}>
        <HashRouter>
            <Switch>
            <Route path="/" exact component={LandingPage} />
                <Route path="/admin/" component={AdminPage} />
                <Route path="/admin-objects/" component={AdminObjects} />
                <Route path="/inspection/" component={InspectionPage} />
                <Route path="/login/" component={LoginPage} />
                <Route path="/manage-account/" component={ChangePswPage} />
                <Route path="/manage-object/:id" component={ManageObject} />
                <Route path="/manage-acc/:id" component={ManageUser} />
                <Route path="/create-acc/:id/type/:type" component={CreateUser} />
                <Route path="/org-cabinet/" component={OrgCabinet} />
                <Route path="/org-profile/" component={OrgProfile} />
                <Route path="/org-users/" component={OrgUsers} />
                <Route path="/appeals" component={Appeals} />
                <Route path="/objects" component={Objects} />
                <Route path="/objects-search" component={ObjectsSearch} />
                <Route path="/notification/:id" component={Notification} />
                <Route path="/notification-card/:id" component={NotificationCard} />
                <Route path="/notifications" component={NotificationsPage} />
                <Route path="/newobject" component={ObjectsPage} />
                <Route path="/inspection-objects" component={ObjectsInspector} />
                <Route path="/inspection-appeals" component={InspectionAppeals} />
                <Route path="/supervision" component={SupervisionPage} />
                <Route path="/conclusions" component={Conclusions} />

             </Switch>
        </HashRouter>
    </Provider>
</MuiThemeProvider>
</MuiPickersUtilsProvider>
);

render(
<App />,
    document.getElementById('app')
);


// WEBPACK FOOTER //
// ./assets/src/js/index.js